import React from 'react';
import { Mail } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="relative border-t border-white/10 py-12">
      <div className="container mx-auto px-6">
        {/* Legal Disclaimer */}
        <div className="max-w-4xl mx-auto mb-10 p-6 bg-orange-500/5 border border-orange-500/20 rounded-xl">
          <p className="text-gray-400 text-sm leading-relaxed">
            <strong className="text-orange-500">Disclaimer:</strong> ShraddhaAI uses AI characters inspired by figures described in Hindu scriptures. The platform does not claim to represent real divine entities and provides spiritual guidance based on interpretations of scriptural texts.
          </p>
        </div>

        <div className="grid md:grid-cols-4 gap-8 max-w-6xl mx-auto mb-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <h3 className="font-serif text-2xl font-bold text-gradient mb-3">
              ShraddhaAI
            </h3>
            <p className="text-gray-400 mb-4">
              Your AI-powered spiritual companion for divine guidance and inner peace.
            </p>
            <div className="flex items-center gap-2 text-gray-400">
              <Mail className="w-4 h-4" />
              <a href="mailto:work.shraddhaai@gmail.com" className="hover:text-orange-500 transition-colors">
                work.shraddhaai@gmail.com
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Company</h4>
            <ul className="space-y-2">
              <li>
                <a href="#about" className="text-gray-400 hover:text-orange-500 transition-colors">
                  About
                </a>
              </li>
              <li>
                <a href="mailto:work.shraddhaai@gmail.com" className="text-gray-400 hover:text-orange-500 transition-colors">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold text-white mb-4">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy-policy" className="text-gray-400 hover:text-orange-500 transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="text-gray-400 hover:text-orange-500 transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/eula" className="text-gray-400 hover:text-orange-500 transition-colors">
                  EULA
                </Link>
              </li>
              <li>
                <Link to="/refund-policy" className="text-gray-400 hover:text-orange-500 transition-colors">
                  Refund Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © 2025 ShraddhaAI. Operated by <span className="text-orange-500 font-semibold">Srivartin Corporation</span>. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;